import React, { useState } from "react";
import { CheckCircle, XCircle } from "../../../../Components/IconComponents";
import SearchBox from "../../../../Components/UiComponents/Table/TableComponents/SearchBox/SearchBox";

const SOPResourceTable = ({ sopInstanceData }) => {
  const allResources = sopInstanceData?.resources || [];
  const [searchValue, setSearchValue] = useState("");
  const term = searchValue.trim().toLowerCase();
  const resources = term
    ? allResources.filter((r) => (r.resource_name || "").toLowerCase().includes(term))
    : allResources;

  return (
    <div className="container mt-2 mb-3">
      {/* Section Title — same style as "SOP Tasks" */}
      <div className="d-flex align-items-center justify-content-between">
        <span style={{ color: "#17a3a0", fontSize: "15px", fontWeight: "700" }}>
          Selected Resources for SOP
        </span>
        <SearchBox
          searchValue={searchValue}
          onSearchHandler={setSearchValue}
          placeholder="Search resource..."
        />
      </div>

      <div className="mt-2" style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #000" }}>
        {/* Column Header */}
        <div className="d-flex align-items-center px-3 py-2" style={{ background: "#1C4E72", color: "#fff" }}>
          <div style={{ width: "45px", flexShrink: 0, fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>S.No.</div>
          <div style={{ flex: 1, fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Resource Name</div>
          <div style={{ width: "90px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Available Qty</div>
          <div style={{ width: "90px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Damaged Qty</div>
          <div style={{ width: "90px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Deployed Qty</div>
          <div style={{ width: "90px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Total Qty</div>
          <div style={{ width: "160px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Qty To Deploy</div>
          <div style={{ width: "100px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Auto</div>
          <div style={{ width: "100px", textAlign: "center", fontWeight: "600", fontStyle: "normal", fontSize: "11px" }}>Manual</div>
        </div>

        {/* Resource Rows */}
        <div style={{ background: "#fff", maxHeight: "280px", overflowY: "auto" }}>
          {resources.length > 0 ? resources.map((resource, index) => (
            <div
              key={index}
              className="d-flex align-items-center px-3 py-1"
              style={{ borderBottom: index < resources.length - 1 ? "1px solid #f0f0f0" : "none", transition: "background 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.background = "#f8f9fa"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}
            >
              {/* S.No. */}
              <div style={{ width: "45px", flexShrink: 0, fontWeight: "400", fontSize: "11px", color: "#1a2e35" }}>{index + 1}.</div>

              {/* Resource Name */}
              <div style={{ flex: 1, fontWeight: "400", fontSize: "11px", color: "#1a2e35" }}>{resource.resource_name || "NA"}</div>

              {/* Cumulative values */}
              <div style={{ width: "90px", textAlign: "center", fontSize: "11px", fontWeight: "400", color: "#1a2e35" }}>
                {resource.cum_available_quantity ?? 0}
              </div>
              <div style={{ width: "90px", textAlign: "center", fontSize: "11px", fontWeight: "400", color: "#1a2e35" }}>
                {resource.cum_damaged_quantity ?? 0}
              </div>
              <div style={{ width: "90px", textAlign: "center", fontSize: "11px", fontWeight: "400", color: "#1a2e35" }}>
                {resource.cum_deployed_quantity ?? 0}
              </div>
              <div style={{ width: "90px", textAlign: "center", fontSize: "11px", fontWeight: "400", color: "#1a2e35" }}>
                {resource.cum_total_quantity ?? 0}
              </div>

              {/* Qty To Deploy */}
              <div style={{ width: "160px", textAlign: "center", fontSize: "11px", fontWeight: "400", color: "#1a2e35" }}>
                {resource.quantity ?? resource.required_quantity ?? "0"}
              </div>

              {/* Auto */}
              <div style={{ width: "100px", textAlign: "center" }}>
                {(resource.is_automatic === true || resource.is_automatic === 1 || resource.is_automatic === "true") ? (
                  <CheckCircle style={{ color: "#28a745", width: "18px", height: "18px" }} />
                ) : (
                  <XCircle style={{ color: "#dc3545", width: "18px", height: "18px" }} />
                )}
              </div>

              {/* Manual */}
              <div style={{ width: "100px", textAlign: "center" }}>
                {(resource.is_manual === true || resource.is_manual === 1 || resource.is_manual === "true") ? (
                  <CheckCircle style={{ color: "#28a745", width: "18px", height: "18px" }} />
                ) : (
                  <XCircle style={{ color: "#dc3545", width: "18px", height: "18px" }} />
                )}
              </div>
            </div>
          )) : (
            <div className="text-center text-muted py-4" style={{ fontSize: "11px" }}>
              {term ? "No matching resources" : "No resources found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SOPResourceTable;
